import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { VideoContext } from './videoContext';
import jsonp from '../modules/base/jsonp';

/**
 * VideoContentProvider
 * 组件数据存储中心及actions处理中心
 */
class VideoContentProvider extends PureComponent {
    static propTypes = {
        initData: PropTypes.object.isRequired,
        children: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        // 默认播放器配置
        const defaultVideoOptions = {
            width: 930,
            height: 530,
            antiTheft: true,
            showSourcesList: false, // 是否展示多source框
            m3u8Play: false, // 是否使用m3u8格式播放
            preload: 'auto',
            controls: true,
            // fluid: true,
            allowResize: false,
            html5: {
                hls: {
                    handleManifestRedirects: true,
                },
            },
            bigPlayButton: false,
            controlBar: {
                progressControl: true,
                playToggle: true,
                nextVideoPanel: true,
                currentTimeDisplay: true,
                timeDivider: true,
                durationDisplay: true,
                volumePanel: {
                    inline: true,
                },
                changeResPanel: false,
                fullscreenToggle: true,
                captionsButton: false,
                playbackRateMenuButton: false,
                liveDisplay: false,
                subtitlesButton: false,
                remainingTimeDisplay: false,
            },
        };

        const {
            initData: {
                videoConfig,
                playermsg: { needBigMutedIcon = false, m3u8Play = false },
                playermsg,
            },
        } = this.props;

        // 处理videoConfig传入格式 [videoObject|Array<videoObject>]
        let cacheVideoConfig = [];

        if (Object.prototype.toString.call(videoConfig) === '[object Object]') {
            cacheVideoConfig = [videoConfig];
        } else if (Object.prototype.toString.call(videoConfig) === '[object Array]') {
            cacheVideoConfig = videoConfig;
        }

        const compatibleSources = this.compatibleFileds(cacheVideoConfig, m3u8Play);

        this.state = {
            videoConfig: cacheVideoConfig,
            playermsg,
            currentPlaySource: compatibleSources[0], // 默认初始播放第一个
            currentPlayIndex: 0, // 默认初始播放顺序
            videoJsOptions: {
                ...defaultVideoOptions,
                ...playermsg,
                sources: compatibleSources,
            },
            narrowWindowMode: false,
            needBigMutedIcon,
        };
    }

    handleContentChange = (action) => {
        const { type, payload, callback } = action;

        switch (type) {
            case 'clickPoster':
                return this.setState({
                    videoJsOptions: {
                        ...this.state.videoJsOptions,
                        autoplay: true,
                        autoPlay: true,
                    },
                });
            case 'changeSource':
                return this.setState(
                    {
                        ...payload,
                    },
                    () => {
                        if (callback) {
                            callback();
                        }
                    },
                );
        }
    };

    /**
     * 兼容视频地址字段
     */
    compatibleFileds = (sources, m3u8Play) => {
        const formatSources = [];

        sources.forEach((itemSource) => {
            const { videoPlayUrl, m3u8Url, videoLargePoster, bigPosterUrl, posterUrl, vid, playUrl, guid, mobileUrl } =
                itemSource;

            /**
             * 视频字段兼容性处理
             * start
             */
            let _videoPlayUrl = videoPlayUrl || playUrl || mobileUrl || '';

            // m3u8形式播放
            if (m3u8Play && _videoPlayUrl && _videoPlayUrl.includes('ips.ifeng.com')) {
                _videoPlayUrl = _videoPlayUrl.replace('.mp4', '/index.m3u8');
            }

            if (m3u8Url && m3u8Play) {
                _videoPlayUrl = m3u8Url;
            }

            formatSources.push({
                ...itemSource,
                src: _videoPlayUrl,
                type: _videoPlayUrl.includes('/index.m3u8') ? 'application/x-mpegURL' : 'video/mp4',
                poster:
                    videoLargePoster ||
                    bigPosterUrl ||
                    posterUrl ||
                    'https://p0.ifengimg.com/a/2017/0905/4aaeeaf1c8c482bsize20_w700_h530.jpg',
                vid: vid || guid || '',
            });
        });

        return formatSources;
    };

    /**
     * 对播放地址添加参数
     * @param {String} sourceUrl
     * @param {String} params
     */
    addSrcParams = (sourceUrl, params) => {
        // 非空判断
        if (!params) {
            return sourceUrl;
        }

        // 判断原链接是否已有参数拼接
        if (sourceUrl.indexOf('?') > 0) {
            return `${sourceUrl}&${params}`;
        }

        return `${sourceUrl}?${params}`;
    };

    // 播放地址整合防盗链
    sourcesCombineAuthUrl = (sources, antiTheft, authUrl) => {
        sources.forEach((source) => {
            // 添加 reqtype=tsl 参数保证302跳转https (搜狗浏览器http跳转被block，加参跳转https)
            // @ 2020-08-25 zhujian 暂时关闭
            let _sourceSrc = this.addSrcParams(source.src, 'reqtype=tsl');
            // let _sourceSrc = source.src;

            if (antiTheft) {
                _sourceSrc = this.addSrcParams(_sourceSrc, authUrl);
            }
            source.src = _sourceSrc.replace('http://ips.ifeng.com', 'https://ips.ifeng.com');
        });

        return sources;
    };

    async componentDidMount() {
        const {
            videoJsOptions,
            videoJsOptions: { sources, antiTheft },
        } = this.state;

        if (typeof window.videoRequestTime === 'undefined') {
            window.videoRequestTime = 1;
        } else {
            window.videoRequestTime = window.videoRequestTime + 1; /* eslint-disable-line */
        }

        let authUrl = '';

        // 关闭视频链接增加防盗链参数功能
        // if (antiTheft) {
        //     const callbackName = `getVideoAuthPath_${window.videoRequestTime}`;
        //     const authConfig = await jsonp(
        //         `https://shankapi.ifeng.com/feedflow/getVideoAuthUrl/${sources[0].vid}/${callbackName}`,
        //         {
        //             jsonpCallback: callbackName,
        //             cache: false,
        //         },
        //     );
        //
        //     if (authConfig && authConfig.data && authConfig.data.success && authConfig.data.authUrl) {
        //         authUrl = authConfig.data.authUrl;
        //     }
        // }

        this.setState({
            videoJsOptions: {
                ...videoJsOptions,
                sources: this.sourcesCombineAuthUrl(sources, antiTheft, authUrl), // 调整vjs sources格式为数组，可传入多个视频
            },
        });

        const {
            initData: {
                playermsg: { allowResize },
            },
        } = this.props;

        if (allowResize) {
            const initWidth = document.body.clientWidth;

            if (initWidth <= 1300) {
                this.setState({
                    narrowWindowMode: true,
                });
            }
        }

        window.onresize = () => {
            if (allowResize) {
                const currentWidth = document.body.clientWidth;

                if (currentWidth <= 1300) {
                    this.setState({
                        narrowWindowMode: true,
                    });
                } else {
                    this.setState({
                        narrowWindowMode: false,
                    });
                }
            }
        };
    }

    render() {
        return (
            <VideoContext.Provider value={{ dispatch: this.handleContentChange, ...this.state }}>
                {this.props.children}
            </VideoContext.Provider>
        );
    }
}

export { VideoContentProvider };
